<template>
  <v-card flat v-if="selectedDestiny != null">
    <v-container class="pa-0">
      <v-card-title class="text-subtitle-1 font-weight-bold">
        Productos&nbsp;<v-icon>mdi-package-variant</v-icon>
      </v-card-title>
      <v-card-subtitle>
        <v-autocomplete
          id="products-anchor"
          ref="productAutocomplete"
          label="Buscar un producto"
          hint="Ctrl + P"
          :search-input.sync="currentSearch"
          :items="searchResults"
          :no-data-text="
            searching == true
              ? 'Buscando...'
              : 'Sin coincidencias para mostar (>.<)'
          "
          @change="addToSelected"
          persistent-hint
          no-filter
          dense
        >
          <template slot="item" slot-scope="{ item }">
            {{ item.item.attributes.descripcion }}
          </template>
        </v-autocomplete>
      </v-card-subtitle>
      <v-card-text>
        <v-container class="pa-0">
          <v-data-table
            :headers="headers"
            :items="selected"
            @focus:row="test"
            hide-default-footer
            disable-pagination
          >
            <template v-slot:item.unit_options="{ item }">
              <v-select
                class="restrained-select"
                :items="item.unit_options"
                :value="item.selected_unit"
                @change="recalc($event, item)"
                dense
              />
            </template>
            <template v-slot:item.precio_unitario_calculado="{ item }">{{
              item.precio_unitario_calculado | currency
            }}</template>
            <template v-slot:item.precio_unitario_final="{ item }">{{
              item.precio_unitario_final | currency
            }}</template>
            <template v-slot:item.total_local="{ item }">{{
              item.total_local | currency
            }}</template>
            <template v-slot:item.cantidad="{ item }">
              <input
                class="restrained larger"
                v-model.number="item.cantidad"
                type="number"
                min="1"
                @input="updateEntryValues(item)"
              />
            </template>
            <template v-slot:item.largo="{ item }">
              <input
                class="restrained"
                v-model.number="item.largo"
                type="number"
                min="0.1"
                step="0.1"
                :disabled="
                  !item.selected_unit ||
                  item.selected_unit.referencia == 'M2' ||
                  item.selected_unit.referencia == 'KG'
                "
                @input="updateEntryValues(item)"
              />
            </template>
            <template v-slot:item.peso_calculado="{ item }">
              {{ item.peso_calculado | number }}
            </template>
            <template v-slot:item.descuento_seleccionado="{ item }">
              <br />
              <input
                class="restrained"
                v-model.number="item.descuento_seleccionado"
                type="number"
                min="0"
                name="discount"
                :max="item.maxDiscount"
                :disabled="item.maxDiscount == 0"
                @input="updateEntryValues(item)"
              />%
              <br />
              <label class="hint" for="discount"
                >0 - {{ item.maxDiscount }}%</label
              >
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn
                fab
                small
                color="accent"
                @click="openDetailDialog(item)"
                v-if="role == 'director' || role == 'gerente'"
              >
                <v-icon>mdi-calculator-variant</v-icon>
              </v-btn>
              &nbsp;
              <v-btn fab small color="warning" @click="deleteItem(item)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
              &nbsp;
              <v-btn
                fab
                small
                class="red lighten-2"
                v-if="item.observaciones != null"
                @mouseenter="setProductInfo($event, item.observaciones)"
                @mouseleave="clearProductInfo"
              >
                <v-icon class="white--text"> mdi-information </v-icon>
              </v-btn>
            </template>
            <template v-slot:no-data
              >No hay datos para mostrar (&gt;.&lt;)</template
            >
          </v-data-table>
        </v-container>
      </v-card-text>
    </v-container>
    <v-container v-if="selectedIsocindu.length > 0" class="mt-2 px-0">
      <v-alert class="warning white--text">
        Recuerde que los productos de la familia
        <span class="font-weight-bold">PANEL ISOCINDU</span> requieren que
        agregue un <span class="font-weight-bold">servicio de flete</span>.
      </v-alert>
    </v-container>
    <v-container v-if="fetching == true && errorFetching == false">
      <v-card-subtitle class="mb-0">
        Cargando catálogo de productos
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-card-subtitle>
    </v-container>
    <v-container v-if="errorFetching == true">
      <v-card-subtitle class="mb-0">
        <img src="@/assets/error.svg" alt="error_img" class="error-img" />
        Ha ocurrido un error al obtener el catálogo de productos <br /><br />
        <v-btn color="warning" class="mx-auto" @click="get">
          <v-icon>update</v-icon>&nbsp; Intentar de nuevo
        </v-btn>
      </v-card-subtitle>
    </v-container>
    <PriceDetailDialog
      :trigger="priceDialog"
      :product="selectedForDetail"
      @onCancel="resetDialog"
    />
    <FloatingInfo
      :showMenu="showInfo"
      :info="productInfo"
      :x="itemX"
      :y="itemY"
    />
  </v-card>
</template>

<script>
import Fuse from "fuse.js";
import PriceDetailDialog from "@/components/Cotizador/PriceDetailDialog";
import FloatingInfo from "@/components/FloatingInfo";
export default {
  components: {
    FloatingInfo,
    PriceDetailDialog,
  },
  data() {
    return {
      searching: false,
      searchValue: "",
      currentSearch: "",
      headers: [
        {
          text: "Cantidad",
          value: "cantidad",
          class: "indigo lighten-5 rounded-l",
        },
        {
          text: "Unidad",
          value: "unit_options",
          class: "indigo lighten-5",
        },
        {
          text: "Descripción",
          value: "descripcion",
          class: "indigo lighten-5",
        },
        {
          text: "Largo",
          value: "largo",
          class: "indigo lighten-5",
        },
        {
          text: "Precio",
          value: "precio_unitario_final",
          class: "indigo lighten-5",
        },
        {
          text: "Descuento",
          value: "descuento_seleccionado",
          class: "indigo lighten-5",
        },
        {
          text: "Importe",
          value: "total_local",
          class: "indigo lighten-5",
        },
        {
          text: "Peso (KG)",
          value: "peso_calculado",
          class: "indigo lighten-5",
        },
        {
          text: "Acciones",
          value: "actions",
          class: "indigo lighten-5 rounded-r",
        },
      ],
      clientDiscounts: [],
      priceDialog: false,
      selectedForDetail: null,
      showInfo: false,
      productInfo: null,
      itemX: null,
      itemY: null,
    };
  },
  computed: {
    role() {
      return this.$store.state.user.role;
    },
    selectedDestiny() {
      return this.$store.state.destinies.selectedDestiny;
    },
    all() {
      return this.$store.state.all;
    },
    selected() {
      return this.$store.state.selected;
    },
    selectedIsocindu() {
      return this.$store.state.isocindu.selectedIsocindu;
    },
    fetching() {
      return this.$store.state.fetching;
    },
    errorFetching() {
      return this.$store.state.errorFetching;
    },
    searchResults() {
      if (this.fuse.search == null) {
        return [];
      }
      return this.fuse.search(this.searchValue);
    },
    fuse() {
      return this.$store.state.fuse;
    },
  },
  methods: {
    addToSelected({ item }) {
      // Check if the item is already in the list.
      const match = this.selected.filter((p) => p.id == item?.id);
      if (match.length > 0) {
        this.$refs.productAutocomplete.reset();
        this.$toasted.show("Este producto ya ha sido seleccionado.", {
          type: "warning",
        });
        return;
      }
      // Prevents store role status loss on page reload. This would result on discounts always being 0.
      if (this.role == null) {
        this.$store.commit(
          "setRole",
          JSON.parse(sessionStorage.getItem("user"))["rol"]
        );
      }
      this.$store.dispatch("addProduct", item);
      this.$store.dispatch("updateQuotationTotals");
      this.$refs.productAutocomplete.reset();
    },
    updateSearch(event) {
      if (this.searching == true) {
        this.currentSearch = event;
        return;
      }
      this.searching = true;
      setTimeout(() => {
        this.searchValue = this.currentSearch;
        this.searching = false;
      }, 500);
    },
    getAll() {
      this.$store.dispatch("getAll");
    },
    updateEntryValues(item) {
      this.$store.dispatch("updateProducts", item);
      this.$store.dispatch("updateQuotationTotals");
    },
    recalc(event, item) {
      item.selected_unit = event;
      this.updateEntryValues(item);
    },
    deleteItem(item) {
      this.$store.dispatch("deleteProduct", item);
      this.$store.dispatch("updateQuotationTotals");
    },
    updateAll() {
      this.$store.dispatch("updateAll");
      this.$store.commit(
        "setFuse",
        new Fuse(this.all, {
          includeScore: true,
          keys: ["attributes.codigo", "attributes.descripcion"],
        })
      );
    },
    openDetailDialog(item) {
      this.selectedForDetail = item;
      this.priceDialog = true;
    },
    resetDialog() {
      this.priceDialog = false;
      this.selectedForDetail = null;
    },
    setProductInfo(e, obs) {
      if (this.showInfo == false) {
        this.productInfo = obs;
        this.itemX = e.clientX;
        this.itemY = e.clientY;
        this.$nextTick(() => {
          this.showInfo = true;
        });
      }
    },
    clearProductInfo() {
      this.showInfo = false;
      this.productInfo = null;
    },
    test() {
      ("row focused");
    },
  },
  watch: {
    currentSearch(newVal) {
      if (newVal == null) {
        this.currentSearch = "";
        this.updateSearch(this.currentSearch);
        return;
      }
      this.updateSearch(newVal);
    },
  },
  created() {
    this.getAll();
  },
};
</script>

<style lang="scss" scoped>
.restrained {
  max-width: 6ch;
  border: 1px solid lightgray;
  border-radius: 0.5rem;
  padding: 0.15rem;

  &.larger {
    max-width: 7ch;
  }

  &:focus {
    outline-color: cadetblue;
  }

  &:disabled {
    background-color: lightgray;
  }
}
.restrained-select {
  max-width: 8ch;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

.hint {
  font-size: x-small;
}

.results-container {
  width: 100%;
  height: 0;
  padding: 0;
  overflow: hidden;
  transition: height 500ms ease, padding 500ms ease;

  @media (min-width: 768px) {
    width: 30%;
    margin-right: 70%;
  }
}

.results-container.open {
  overflow-y: scroll;
  height: 240px;
  padding: 1rem 0;
}

.error-img {
  display: block;
  margin: 1rem auto;
  max-height: 80px;
  width: auto;
}
</style>